import type { ReactNode } from "react";
import styles from "./Toast.module.css";

export function Toast({ message, action }: { readonly message: string; readonly action?: ReactNode }) {
  return (
    <div className={styles.toast} role="status">
      <span className={styles.message}>{message}</span>
      {action}
    </div>
  );
}
